import React, {Component} from "react";
import PropTypes from "prop-types";
import {Col, Row, Glyphicon} from 'react-bootstrap'
import {TableHeaderColumn} from "react-bootstrap-table";
import * as Grid from "../utils/grid"
import {Date} from "../utils";

const getInterCodes = () => {
	return ["00", "01", "10", "11", "20", "21", "30", "31", "40", "41"];
};

const formatRank = (cell, row) => {
	if (cell <= 0) {
		if (row.isDnf) {
			return 'DNF'
		} else if (row.isDns) {
			return 'DNS'
		} else if (row.isDisqualified) {
			return 'DSQ'
		}
		return ''
	}
	return cell
};

const formatFullName = (cell, row) => {
	return row.firstName ? (cell + ' ' + row.firstName[0] + '.') : cell
};

const formatTotalTime = (cell, row) => {
	if (row.r > 1) {
		return formatTime(row.b, '+')
	}
	return formatTime(cell)
};

const formatTime = (time, prefix = "") => {
	if (time === 0) {
		return prefix + "0,0"
	}
	if (!time) {
		return null
	}
	if (time >= 600) {
		const m = ("00" + (Math.floor((time % 600) / 10)));
		return prefix + Math.floor(time / 600)
			+ ":" + m.substring(m.length - 2)
			+ "," + ((time % 600) % 10)

	} else {
		return prefix + Math.floor((time % 600) / 10)
			+ "," + ((time % 600) % 10)
	}
};

const scrollToAnchor = (anchor) => {
	let hash = window.location.hash;
	if (hash.lastIndexOf('#') > 1) {
		hash = hash.substring(0, hash.lastIndexOf('#'));
	}
	window.location.hash = hash + (anchor || '');
	if (!anchor) {
		document.getElementById('result-tabs').scrollIntoView();
	}
};

const formatRow = (row, code, lastResults) => {
	const key = row.compGroupId + '-' + row.racerId;
	if (row.tt > 0
		&& lastResults[code]
		&& lastResults[code][key]
		&& lastResults[code][key].update > (Date.currentTS() - 10)) {
		return "flashit";
	}
	return null;
};

export default class ResultIntermediates extends Component {

	renderResultIntermediates(info, items, code, ranked, isLoader) {
		if (!items || !items.length) {
			return null
		}

		const cols = [
			<TableHeaderColumn key="1" dataField="r" width='10%' dataAlign="right" dataFormat={formatRank}>
				{ranked ? <span title={"Pořadí"}><Glyphicon glyph="stats"/></span> : ''}
			</TableHeaderColumn>,
			<TableHeaderColumn key="2" dataField="startOrder" width='10%' dataAlign="right"><span title={"Startovní číslo"}>#</span></TableHeaderColumn>,
			<TableHeaderColumn key="3" dataField="lastName" width='30%' dataAlign="left" dataFormat={formatFullName}>Jméno</TableHeaderColumn>
		];
		// if ("00" === code) {
		cols.push(<TableHeaderColumn key="4" dataField="clubAbbr" width='30%' dataAlign="left">Klub</TableHeaderColumn>);
		// }

		cols.push(<TableHeaderColumn key="10" dataField="tt" width='20%' dataAlign="right" dataFormat={formatTotalTime}>{ranked ? 'Čas' : ''}</TableHeaderColumn>);

		const filter = {};
		const options = Grid.getTableOptions(filter);
		if (!items.length) {
			return null
		}

		return <div style={isLoader ? {opacity: 0.2} : {}}>
			{ranked ? <h4>Mezičas {code}<a className={"hidden visible-xs pull-right"} onClick={() => scrollToAnchor()}>nahoru</a></h4> :
				<h3>Na trati, DNF, DNS, DSQ</h3>}
			{Grid.renderTable(items, items.length, options, cols, false, true, 'table-ResultIntermediates', true, (row) => formatRow(row, code, this.props.lastResults))}
		</div>
	}

	render() {
		const {raceInfo, raceResult} = this.props;

		if (!raceInfo || raceInfo.item === null) {
			return Grid.renderIsFetchingData("Závod se nahrává ...");
		}
		const info = raceInfo.item;
		const race = info.race;
		if (!race || !race.raceId) {
			return <span>Závod nenalezen</span>
		}

		let isLoader = raceResult.isFetchingItem && raceResult.item && raceResult.item.resultUsers;

		const tables = {};
		if (raceResult && raceResult.item && raceResult.item.resultUsers) {
			for (let i = 0; i < raceResult.item.resultUsers.length; i++) {
				const ru = raceResult.item.resultUsers[i];
				if (!ru.intermediates || !ru.intermediates.length) {
					continue;
				}
				for (let j = 0; j < ru.intermediates.length; j++) {
					const inter = ru.intermediates[j];
					if (!tables.hasOwnProperty(inter.c)) {
						tables[inter.c] = []
					}
					tables[inter.c].push({
						racerId: ru.racerId,
						compGroupId: ru.compGroupId,
						firstName: ru.firstName,
						lastName: ru.lastName,
						startOrder: ru.startOrder,
						clubAbbr: ru.clubAbbr,
						...inter
					})
				}
			}
		}

		const codes = getInterCodes();
		const cols = [];
		const codeLinks = [];
		for (let i = 0; i < codes.length; i++) {
			const code = codes[i];
			if (!tables.hasOwnProperty(code)) {
				continue
			}
			const items = tables[code].sort((item1, item2) => {
				if (!item1.r) {
					return -1
				}
				if (item1.r > item2.r) {
					return 1
				}
				if (item1.r < item2.r) {
					return -1
				}
				return item1.startOrder < item2.startOrder ? -1 : 1
			});
			cols.push(<Col key={code} sm={6} id={'inter-' + code}>
				{this.renderResultIntermediates(info, items, code, true, isLoader)}
			</Col>);
			codeLinks.push(<li key={code}><a onClick={() => scrollToAnchor('#inter-' + code)}>Mezičas {code}</a></li>)
		}
		const groups = [];
		let group = [];
		for (let i = 0; i < cols.length; i++) {
			group.push(cols[i]);
			if (group.length >= 2) {
				groups.push(<Col className={"inter-group"} md={6} key={i}>{group}</Col>);
				group = [];
			}
		}
		if (group.length) {
			groups.push(<Col className={"inter-group"} md={6} key={'last'}>{group}</Col>);
		}

		const rows = [];
		let row = [];
		for (let i = 0; i < groups.length; i++) {
			row.push(groups[i]);
			if (row.length >= 2) {
				rows.push(<Row key={i}>{row}</Row>);
				row = [];
			}
		}
		if (row.length) {
			rows.push(<Row key={'last'}>{row}</Row>);
		}

		// const notRanked = raceResult.item && raceResult.item.resultUsers
		// 	? raceResult.item.resultUsers.filter((item) => item.rank <= 0) : null;

		return (
			<div>
				<div className={"hidden visible-xs nav nav-pills nav-stacked"}>
					{codeLinks}
				</div>
				{rows.length ? rows : (raceResult.item === null ? Grid.renderIsFetchingData("Mezičasy se nahrávají ...") : <span>Mezičasy nenalezeny</span>)}
				{/*<Row>*/}
				{/*{this.renderResultIntermediates(info, notRanked, null, false)}*/}
				{/*{this.renderPenalties(raceResult)}*/}
				{/*</Row>*/}
			</div>
		);
	}
}


ResultIntermediates.propTypes = {
	seasons: PropTypes.object,
	raceInfo: PropTypes.object,
	compGroupId: PropTypes.string,
	raceResult: PropTypes.object,
	lastResults: PropTypes.object
};



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/result/ResultIntermediates.js